import React from 'react';

const RaBanner = () => (
    <React.Fragment>
        <div className='ra-banner-2025'>
            <img src="/assets/images/ra/selo2026.svg" alt="ra-banner" className="ra-img" />
            <div className="ra-banner-textBox">
                <strong className="ra-banner-title">Prêmio RA 2026</strong>
                <span className="ra-banner-subtitle">Agora que já finalizou o seu pedido, que tal deixar seu voto para o Seguros Promo no prêmio Reclame Aqui 2026? Já somos parte da história da sua viagem, agora você pode fazer parte da nossa!</span>
                <a href="https://www.reclameaqui.com.br/premio/votacao/seguros/seguros-viagem?utm_source=category_link&utm_campaign=premio_cat_tKLwc-o5FeJ8ScB1" className="ra-banner-link">Clique aqui para votar.</a>
                <span className="ra-banner-subtitle">
                    Para votar é simples, <a href="https://www.reclameaqui.com.br/premio/votacao/seguros/seguros-viagem?utm_source=category_link&utm_campaign=premio_cat_tKLwc-o5FeJ8ScB1" className="ra-banner-link">acesse a página da votação</a>, faça o login na sua conta do Reclame Aqui e <strong>vá até a nossa categoria “Seguros” em “Seguros de viagem”.</strong> Pronto, agora é só votar no Seguros Promo.
                </span>
                <p className="ra-banner-subtitle">Agradecemos por votar na gente!</p>
            </div>
        </div>
    </React.Fragment>
);
export default RaBanner;



// WEBPACK FOOTER //
// ./src/components/purchase_status/RaBanner.jsx